import { assignmentErrorMessages } from '@repo/lib/messages/assignmentErrorMessages';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useErrorMessage } from '#error-message/useErrorMessage';

import type { EditAssignmentInput } from './assignmentService';

import { AssignmentService } from './assignmentService';
import { invalidateAssignedAssignments } from './invalidateAssignedAssignments';
import { AssignmentKey } from './keys';

export function useEditAssignment() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (input: EditAssignmentInput) => AssignmentService.editAssignment(input).then((response) => response.data),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [AssignmentKey.ASSIGNMENT, variables.data.id],
      });
      invalidateAssignedAssignments(queryClient);
    },
  });

  const errorMessage = useErrorMessage(mutation.error, assignmentErrorMessages);

  return { ...mutation, errorMessage };
}
